import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import BrandIcon from 'components/brand-icon';

import { Wrap } from './styled';
import theme from './theme';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 90%;
  ${Styles.desktop`
    max-width: ${Styles.layout.smallerSectionMaxWidth};
  `}

  svg {
    fill: ${Styles.color.primary};
    width: 100px;
  }
`;

const Header = styled.h1`
  color: ${theme.headerColor};
  font-family: ${Styles.fontFamily.base};
  font-size: 2rem;
  line-height: 1;
  margin-bottom: 0;
  text-transform: uppercase;
`;

export const CateringMessageView = () => {
  const { formatMessage } = useIntl();

  return (
    <Wrap>
      <Container>
        <BrandIcon />
        <Header>{formatMessage({ id: 'cateringNoOffersMessage' })}</Header>
      </Container>
    </Wrap>
  );
};
